// Google Cloud Storage Configuration
const GCS_CONFIG = {
  // Base URL for Google Cloud Storage
  BASE_URL:
    process.env.REACT_APP_GCS_BASE_URL ||
    "https://storage.googleapis.com/elf_shipping_bucket",

  // Folder structure in GCS
  FOLDERS: {
    AWARDS: "awards",
    GALLERY: "gallery",
    NEWS: "news",
    STATIC: "static", // For static images like logos, backgrounds, etc.
    CLIENTS: "clients",
    ABOUT: "about",
    HOME: "home",
    SERVICES: "services",
  },
};

// Helper function to construct GCS URLs
export const getGCSUrl = (folder, filename) => {
  if (!filename) return "";

  // If it's already a full URL, return as is
  if (filename.startsWith("http")) {
    return filename;
  }

  // Remove leading ./ or / from filename
  const cleanFilename = filename.replace(/^\.?\//, "");

  return `${GCS_CONFIG.BASE_URL}/${folder}/${cleanFilename}`;
};

// Helper function to get static image URL
export const getStaticImageUrl = (filename) => {
  return getGCSUrl(GCS_CONFIG.FOLDERS.STATIC, filename);
};

// Helper function to get client logo URL
export const getClientLogoUrl = (filename) => {
  return getGCSUrl(GCS_CONFIG.FOLDERS.STATIC, `clients/logos/${filename}`);
};

// Helper function to get about page image URL
export const getAboutImageUrl = (filename) => {
  return getGCSUrl(GCS_CONFIG.FOLDERS.STATIC, `about/${filename}`);
};

// Helper function to get home page image URL
export const getHomeImageUrl = (filename) => {
  return getGCSUrl(GCS_CONFIG.FOLDERS.STATIC, `home/${filename}`);
};

// Helper function to get services image URL
export const getServicesImageUrl = (filename) => {
  return getGCSUrl(GCS_CONFIG.FOLDERS.STATIC, `services/${filename}`);
};

export default GCS_CONFIG;
